import React, { useEffect, useRef, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import DocViewer, { DocViewerRenderers, IDocument } from "@cyntler/react-doc-viewer";
import mammoth from "mammoth";
import "@cyntler/react-doc-viewer/dist/index.css";
import { FormSectionElements } from '../../entities/formTemplateDataType';
import { fileTypeList } from '../../entities/Constants';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString();

type FilePreviewProps = {
    field: FormSectionElements;
    file: File;
    lang: 'en' | 'fr';
};

export const PdfPreviewComponent = ({field, file, lang}: FilePreviewProps) => {
    const [numPages, setNumPages] = useState<number>();
    const [pageNumber] = useState<number>(1);

    const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
        setNumPages(numPages);
    };

    return (
        <>
            <Document file={file} onLoadSuccess={onDocumentLoadSuccess}>
            {Array.from(new Array(numPages), (_el, index) => (
              <Page
                key={`page_${index + 1}`}
                pageNumber={index + 1}
                // renderTextLayer={false}
                // renderAnnotationLayer={false}
              />
            ))}
          </Document>
          {/* <p>Page {pageNumber} of {numPages}</p> */}
        </>
    );
};

export const DocViewerComponent = ({file}: {file: File}) => {
    const getFileType = (file?: File) => {
        const types = fileTypeList.filter(type => type.val.some(val => val.mimeType === file.type))?.[0];
        if (types) {
            const type = types.val.map(val => val.mimeType === file.type ? val.ext : null).filter(Boolean)?.[0] || '';
            return type
        }
        return '';
    }

    const [docs, setDocs] = useState<IDocument[]>([{
        uri: window.URL.createObjectURL(file),
        fileName: file.name,
        fileType: getFileType(file),
    }]);

    // useEffect(() => {
    //     if (!file) return;
    //     file.arrayBuffer().then(content =>
    //         setDocs([{ uri: window.URL.createObjectURL(file), fileData: content, fileType: getFileType(file)}])
    //     ).catch(err => {
    //         console.error('load file content error', err);
    //         setDocs([]);
    //     });
    // }, [file]);

    return (
        <>
            {docs.length && (
                <DocViewer documents={docs} pluginRenderers={DocViewerRenderers} />
            )}
        </>
    )
};

export const ImageViewerComponent = ({imageData, filename, imageType}: {imageData: string; filename: string; imageType: string}) => {
    const data = imageData.split(';base64,');
    const type = data[0].split(':')[1];
    const bytes = atob(data[1]);
    const buffer=Uint8Array.from(bytes, c => c.charCodeAt(0));
    const blob=new Blob([buffer], { type });
    const url=URL.createObjectURL(blob);

    return (
        <>
            <div className='ontrario-margin-top-24-! ontario-margin-bottom-24-! file-preview-title'>{filename}</div>
            <div style={{display: 'flex', justifyContent: 'center', width: '100%', height: '90%'}}>
                <iframe src={url} width='100%' height='100%' style={{border: 'none'}}/>
            </div>
        </>
    )
};

export const MsDocViewer = ({docData, fileName}: {docData: string; fileName: string}) => {
    
    const [html, setHtml] = useState('');

    useEffect(() => {
        if (docData) {
            convertToHtml(docData);
        }
    }, [docData]);

    const convertToHtml = async (doc: string) => {
        try {
            const data = docData.split(';base64,');
            const bytes = atob(data[1]);
            const buffer=Uint8Array.from(bytes, c => c.charCodeAt(0));
            const buff = buffer.buffer;
            const view = await mammoth.convertToHtml({arrayBuffer: buffer.buffer});
            setHtml(view.value);
        } catch (err) {
            console.error(err.message);
            setHtml(`<p><strong>Preview file ${fileName} failed<strong><p>`);
        }
    }

    return (
        <>
            <div className='ontrario-margin-top-24-! ontario-margin-bottom-24-! file-preview-title'>{fileName}</div>
            <div dangerouslySetInnerHTML={{__html: html}} />
        </>
    )
}